/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TenantOrgCapabilitiesRollout { 
    /**
     * Enable rollout APIs.
     */
    enabled?: boolean;
    /**
     * Allow rescheduling of a target into another wave.
     */
    target_reschedule_allowed?: boolean;
}

